import { Navigate, useLocation, useParams } from 'react-router-dom';
import { ActivityListPage } from './ActivityListPage';
import { ConnectDiscontinuedPage } from './ConnectDiscontinuedPage';
import { ActivityCockpitRedirect } from '../cockpit/ActivityCockpitRedirect';
import { SkillManagementPage } from './SkillManagementPage';
import { ProjectManagementPage } from './ProjectManagementPage';
import { ControlPlaneActivityCreationPage } from '../activity-creation';

const RESERVED_SEGMENTS = new Set([
  'skills',
  'project-members',
  'new',
  'connect',
  'cli',
  'metrics',
]);

export const SpassuCodePage = () => {
  const location = useLocation();
  const params = useParams();

  // FlatRoutes consumes the full path, so we detect /skills via location
  if (location.pathname.endsWith('/skills')) {
    return <SkillManagementPage />;
  }

  // Project management: /spassu-code/project-members
  if (location.pathname.endsWith('/project-members')) {
    return <ProjectManagementPage />;
  }

  if (location.pathname.endsWith('/new/control-plane')) {
    return <ControlPlaneActivityCreationPage />;
  }

  // Only Control Plane accepts new activities; the historical /new entry
  // forwards to its creation page.
  if (location.pathname.endsWith('/new')) {
    return <Navigate replace to={`${location.pathname}/control-plane`} />;
  }

  // Historical cockpit links forward to the Control Plane cockpit.
  const metricsMatch = location.pathname.match(
    /\/spassu-code\/metrics\/([^/]+)\/?$/,
  );
  if (metricsMatch) {
    return <ActivityCockpitRedirect activityId={metricsMatch[1]} />;
  }

  // Ancorado no fim: `/connect/<id>/qualquer-coisa` NÃO é endereço de conexão.
  // Sem a âncora, o segmento extra era descartado em silêncio e a página abria
  // para o primeiro segmento — endereço malformado tratado como válido.
  const connectMatch = location.pathname.match(
    /\/spassu-code\/connect\/([^/]+)\/?$/,
  );
  if (connectMatch) {
    return <ConnectDiscontinuedPage activityId={connectMatch[1]} />;
  }

  const cliMatch = location.pathname.match(/\/spassu-code\/cli\/([^/]+)\/?$/);
  if (cliMatch) {
    return <ConnectDiscontinuedPage activityId={cliMatch[1]} />;
  }

  // Historical activity links resolve like a connection link: Control Plane
  // activities open their dedicated connection page. Only a single,
  // non-reserved segment is an activity id; malformed addresses fall back to
  // the list instead of being dispatched as an id.
  const activityId = params.activityId ?? params['*'];
  if (
    activityId &&
    !activityId.includes('/') &&
    !RESERVED_SEGMENTS.has(activityId)
  ) {
    return <ConnectDiscontinuedPage activityId={activityId} />;
  }

  // Default: activity list
  return <ActivityListPage />;
};
